import * as http from '@/util/http'
import { z } from 'zod'

type Lang = 'ja' | 'en'
type LabBaseAuthPath =
  | 'signin'
  | 'signup/select'
  | 'phone_number/update'
  | 'update/email'
  | 'withdrawal'

export let PUBLIC_AUTH_BASE_URL = ''

function joinPaths(...paths: string[]) {
  return paths
    .map((p) => p.replace(/^\/+|\/+$/g, ''))
    .filter(Boolean)
    .join('/')
}

export type Brand<K, T> = K & { __brand: T }

/** Makes all properties of an object type optional and non-nullable. */
export type NonNullablePartial<T> = {
  [K in keyof T]?: NonNullable<T[K]>
}

export type Seconds = Brand<number, 'secs'>

export type AuthResult = {
  accessToken: string
  refreshUntil: Seconds
}

export async function setJwt() {
  const { data: lbJwt } = await http.get<AuthResult>(`${PUBLIC_AUTH_BASE_URL}/api/v2/token`)
  await http.post('/auth/v1/token', { payload: lbJwt })
}

export const UserDetailsSchema = z.object({
  gaid: z.string(),
  emailAddress: z.email(),
  phoneNumber: z.string(),
  category: z.any(),
})

export type UserDetails = z.infer<typeof UserDetailsSchema>

export async function fetchLabBaseAuthUserDetails() {
  const { data } = await http.get<UserDetails>(`${PUBLIC_AUTH_BASE_URL}/api/v1/user/details`)
  return data
}

export function redirectToLabBaseAuthPage(
  callbackPath: string,
  action: LabBaseAuthPath,
  lang: Lang = 'ja'
) {
  window.location.assign(
    `${PUBLIC_AUTH_BASE_URL}/${lang}/${action}?next=${joinPaths(window.location.origin, callbackPath)}`
  )
}

export type AuthDomain = {
  domain_name: string
}

export async function fetchAuthURL() {
  const { data } = await http.get<AuthDomain>('/auth/v1/auth-domain')
  PUBLIC_AUTH_BASE_URL = `https://auth.${data.domain_name}`
}
